import { css } from '@emotion/react';
import { TextSubtitle3RMMixin } from '@mobalytics/shared';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { AccountsButton } from '../../../ui/buttons/accounts-button/accounts-button.component';
import { MascotLayout } from '../../../ui/layout/mascot-layout/mascot-layout.component';
import { genErrorRedirectUrl, genPaymentV2Path } from '../../../utils/formatter/path.formatter';
import { formatPaymentErrorDescription } from '../../payment/utils/format-payment-error-description.util';
import { formatPaymentErrorTitle } from '../../payment/utils/format-payment-error-title.util';
import { PaymentError } from '../payment-error.types';

interface Props {
  className?: string;
  productId: string;
  priceId?: string;
  errorCode: PaymentError;
}

export const Error: React.FC<Props> = (props) => {
  const { className, productId, priceId, errorCode } = props;
  const { t } = useTranslation();
  const { replace } = useHistory();
  const { search } = useLocation();

  const returnBackToApp = () => {
    window.location.href = genErrorRedirectUrl();
  };

  return (
    <MascotLayout
      className={className}
      title={formatPaymentErrorTitle(t, errorCode) || t('Payment declined')}
      description={
        formatPaymentErrorDescription(t, errorCode) || t('Please try another card or different payment method.')
      }
      mascotEmotion={'sad'}
      css={wrapperCss}
    >
      <p css={linkCss} onClick={returnBackToApp}>
        {t('Go back')}
      </p>
      <AccountsButton
        analyticsButtonName="Try again"
        onClick={() => replace(genPaymentV2Path(search, productId, priceId, undefined, undefined))}
      >
        {t('try again')}
      </AccountsButton>
    </MascotLayout>
  );
};

const wrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const linkCss = css`
  ${TextSubtitle3RMMixin};
  cursor: pointer;
  color: var(--general-gold-300);
`;
